import { CURRENCY, CONTRACT_ID, STORE_ID, CATALOG_ID } from '@Config/app.config';
import { getLanguageCode } from '@Utils/language/language';

export const getProductSuggestionsBySearchTerm = (searchTerm: string): types.endpoints.IEndpointConfig => {
	return {
		url: `/search/resources/store/${STORE_ID}/sitecontent/productSuggestionsBySearchTerm/${searchTerm}?contractId=${CONTRACT_ID}&currency=${CURRENCY}&storeId=${STORE_ID}&langId=${getLanguageCode()}&catalogId=${CATALOG_ID}`,
	};
};
